import { MOBILE_BREAKING_POINT, TABLET_BREAKING_POINT } from "@ui/style";
import { useEffect, useMemo, useState } from "react";

export enum ResponsiveDeviceType {
	Mobile = "Mobile",
	Tablet = "Tablet",
	Desktop = "Desktop",
}

interface UseDimenionsHook {
	responsiveDeviceType: ResponsiveDeviceType;
	isMobile: boolean;
	isTablet: boolean;
	isDesktop: boolean;
	isTouchDevice: boolean;
}

export const useDimensions = (): UseDimenionsHook => {
	const [windowWidth, setWindowWidth] = useState(NaN);

	useEffect(() => {
		function handleResize() {
			setWindowWidth(window.innerWidth);
		}

		window.addEventListener("resize", handleResize);
		handleResize();
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const responsiveDeviceType = useMemo((): ResponsiveDeviceType => {
		if (windowWidth <= MOBILE_BREAKING_POINT) {
			return ResponsiveDeviceType.Mobile;
		} else if (windowWidth <= TABLET_BREAKING_POINT) {
			return ResponsiveDeviceType.Tablet;
		} else {
			return ResponsiveDeviceType.Desktop;
		}
	}, [windowWidth]);

	const isMobile = useMemo(() => responsiveDeviceType === ResponsiveDeviceType.Mobile, [responsiveDeviceType]);
	const isTablet = useMemo(() => responsiveDeviceType === ResponsiveDeviceType.Tablet, [responsiveDeviceType]);
	const isDesktop = useMemo(() => responsiveDeviceType === ResponsiveDeviceType.Desktop, [responsiveDeviceType]);
	const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

	return { responsiveDeviceType, isMobile, isTablet, isDesktop, isTouchDevice };
};
